module.exports = __webpack_public_path__ + "img/mobile_qr_code.af0fd243.jpg";